import { format } from 'date-fns';

// ISO date-time with no Z/offset: the API sends these for DateTimeKind.Unspecified values, which are already Eastern wall-clock times.
export const UNZONED_ISO_DATE_TIME = /^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}(:\d{2}(\.\d+)?)?$/;

// Formats an instant as it reads on an Eastern (America/New_York) clock, whatever the device time zone is.
export const formatDate = (date?: Date | string | null, formatString: string = 'M/d/yyyy') => {
    if (!date) {
        return '';
    }
    const convertedDate = new Date(date);
    if (isNaN(convertedDate.getTime())) {
        return '';
    }

    if (typeof date === 'string' && UNZONED_ISO_DATE_TIME.test(date)) {
        // Parsed as device-local, so the wall-clock fields already match the Eastern time the server meant.
        return format(convertedDate, formatString);
    }

    const estConvertedDate = new Date(convertedDate.toLocaleString('en-US', { timeZone: 'America/New_York' }));
    return format(estConvertedDate, formatString);
};

export const convertYYYYMMDDToDate = (dateString: string) => {
    const dateParts = dateString.split('-').map((part) => parseInt(part, 10));
    const date = new Date(dateParts[0], dateParts[1] - 1, dateParts[2]);
    return date;
};

export const formatTime = (date?: Date | string | null) => {
    if (!date) {
        return '';
    }
    return new Date(date).toLocaleString('en-US', { hour: 'numeric', minute: 'numeric', hour12: true, timeZone: 'America/New_York' });
};

export const formatEasternTime = (date?: Date | string | null) => {
    if (!date) {
        return '';
    }
    return `${formatTime(new Date(date))} ET`;
};

// yyyy-MM-dd of the given instant on the Eastern calendar; safe to compare as strings.
export const toEasternDateKey = (date: Date | string) => {
    return new Date(date).toLocaleDateString('en-CA', { timeZone: 'America/New_York' });
};

export const addDays = (date: Date, days: number) => {
    const newDate = new Date(date);
    newDate.setDate(date.getDate() + days);
    return newDate;
};
